import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { __rest as o } from "../_virtual/_tslib.js";
import { jsx as r } from "react/jsx-runtime";
import { Title as e } from "@vds-core/typography";
import { calculateRem as t } from "@vds-core/utilities";
import { ColorTokens as i } from "@vds-tokens/color";
import { LayoutTokens as l } from "@vds-tokens/layout";
import s from "styled-components";
var a = s.div.withConfig({
    displayName: "TitleWrapper",
    componentId: "VDS__sc-ha10xe-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-bottom: ", ";\n"])), t(l.space["1X"].value)),
  m = function m(t) {
    var l = t.surface,
      s = t.bold,
      m = t.children,
      n = t.viewport,
      d = o(t, ["surface", "bold", "children", "viewport"]);
    return r(a, {
      children: r(e, Object.assign({}, d, {
        color: "dark" === l ? i.elements.primary.ondark.value : i.elements.primary.onlight.value,
        size: "small",
        viewport: n,
        bold: s,
        tabIndex: -1,
        children: m
      }))
    });
  };
m.defaultProps = {
  surface: "light"
}, m.displayName = "AccordionTitle";
export { m as default };